/**
 * Get appropriate icon for a bot based on its name
 * @param {Object} bot - The bot object
 * @returns {string} Icon emoji for the bot
 */
export const getBotIcon = (bot) => {
  if (!bot || !bot.name) return "🤖";

  const name = bot.name.toLowerCase();
  if (name.includes("handbook")) return "📚";
  if (name.includes("snap")) return "🍎";
  if (name.includes("medicaid")) return "🏥";
  if (name.includes("savings")) return "💰";
  if (name.includes("deposit")) return "💳";
  return "🤖";
};
